import React, { useState, useEffect } from 'react';
import './Contact.css';
import TestUpdate from './TestUpdate';
import OperationalUpdate from './OperationalUpdate';

function CircuitBreakerTestForm({ goBack, savedGeneralData, reportToUpdate, isUpdateMode }) {
  
  const loadFromLocalStorage = () => {
    try {
      const savedData = localStorage.getItem('updateTimeIntervalData');
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        return {
          numberOfCoils: parsedData.numberOfCoils || 1,
          timingValues: parsedData.timingValues || {},
          contactResistance: parsedData.contactResistance || { R: '', Y: '', B: '' },
          coilResistance: parsedData.coilResistance || {
            closing: { value: '', unit: 'Ω' },
            tripping: {},
            spring: { value: '', unit: 'Ω' }
          }
        };
      }
    } catch (error) {
      
    }
    
    
    return {
      numberOfCoils: 1,
      timingValues: {},
      contactResistance: { R: '', Y: '', B: '' },
      coilResistance: {
        closing: { value: '', unit: 'Ω' },
        tripping: {},
        spring: { value: '', unit: 'Ω' }
      }
    };
  };

  
  const defaultData = loadFromLocalStorage();
  const [numberOfCoils, setNumberOfCoils] = useState(defaultData.numberOfCoils);
  const [showCircuitBreakerForm, setShowCircuitBreakerForm] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [timingValues, setTimingValues] = useState(defaultData.timingValues);
  const [contactResistance, setContactResistance] = useState(defaultData.contactResistance);
  const [coilResistance, setCoilResistance] = useState(defaultData.coilResistance);


  useEffect(() => {
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        
        const testData = reportToUpdate.test_data || {};
        const contactFormData = testData.contactData || {};
        
     
        if (contactFormData.contactResistance) {
          const cr = contactFormData.contactResistance;
          setContactResistance({
            R: cr.R || cr.r || cr.reading_1?.R || '',
            Y: cr.Y || cr.y || cr.reading_1?.Y || '',
            B: cr.B || cr.b || cr.reading_1?.B || ''
          });
        }
        
       
        if (contactFormData.coilResistance) {
          const coilRes = contactFormData.coilResistance;
          
      
          if (coilRes.closing) {
            const closing = coilRes.closing;
            setCoilResistance(prev => ({
              ...prev,
              closing: {
                value: closing.value || closing.reading_1?.value || '',
                unit: closing.unit || closing.reading_1?.unit || 'Ω'
              }
            }));
          }
          
        
          if (coilRes.tripping && typeof coilRes.tripping === 'object') {
            const tripping = {};
            Object.keys(coilRes.tripping).forEach(key => {
              const tc = coilRes.tripping[key];
              tripping[key] = {
                value: tc?.value || tc?.reading_1?.value || '',
                unit: tc?.unit || tc?.reading_1?.unit || 'Ω'
              };
            });
            setCoilResistance(prev => ({
              ...prev,
              tripping
            }));
            
          
            const coilCount = Object.keys(tripping).length;
            if (coilCount > 0) {
              setNumberOfCoils(coilCount);
            }
          }
          
        
          if (coilRes.spring) {
            const spring = coilRes.spring;
            setCoilResistance(prev => ({
              ...prev,
              spring: {
                value: spring.value || spring.reading_1?.value || '',
                unit: spring.unit || spring.reading_1?.unit || 'Ω'
              }
            }));
          }
        }
        
       
        if (contactFormData.timingValues) {
          const tv = contactFormData.timingValues;
       
          const timing = {};
          Object.keys(tv).forEach(key => {
            timing[key] = tv[key] || '';
          });
          setTimingValues(timing);
        }
        
     
        let finalNumberOfCoils = defaultData.numberOfCoils;
        if (contactFormData.numberOfCoils) {
          finalNumberOfCoils = contactFormData.numberOfCoils;
          setNumberOfCoils(finalNumberOfCoils);
        }
        
      
        const finalContactResistance = contactFormData.contactResistance ? {
          R: contactFormData.contactResistance.R || contactFormData.contactResistance.r || contactFormData.contactResistance.reading_1?.R || '',
          Y: contactFormData.contactResistance.Y || contactFormData.contactResistance.y || contactFormData.contactResistance.reading_1?.Y || '',
          B: contactFormData.contactResistance.B || contactFormData.contactResistance.b || contactFormData.contactResistance.reading_1?.B || ''
        } : defaultData.contactResistance;
        
        const finalCoilResistance = { ...defaultData.coilResistance };
        if (contactFormData.coilResistance) {
          if (contactFormData.coilResistance.closing) {
            finalCoilResistance.closing = {
              value: contactFormData.coilResistance.closing.value || contactFormData.coilResistance.closing.reading_1?.value || '',
              unit: contactFormData.coilResistance.closing.unit || contactFormData.coilResistance.closing.reading_1?.unit || 'Ω'
            };
          }
          if (contactFormData.coilResistance.tripping) {
            finalCoilResistance.tripping = {};
            Object.keys(contactFormData.coilResistance.tripping).forEach(key => {
              const tc = contactFormData.coilResistance.tripping[key];
              finalCoilResistance.tripping[key] = {
                value: tc?.value || tc?.reading_1?.value || '',
                unit: tc?.unit || tc?.reading_1?.unit || 'Ω'
              };
            });
            finalNumberOfCoils = Math.max(finalNumberOfCoils, Object.keys(finalCoilResistance.tripping).length);
          }
          if (contactFormData.coilResistance.spring) {
            finalCoilResistance.spring = {
              value: contactFormData.coilResistance.spring.value || contactFormData.coilResistance.spring.reading_1?.value || '',
              unit: contactFormData.coilResistance.spring.unit || contactFormData.coilResistance.spring.reading_1?.unit || 'Ω'
            };
          }
        }
        
        const finalTimingValues = contactFormData.timingValues || defaultData.timingValues;
        
      
        const dataToSave = {
          numberOfCoils: finalNumberOfCoils,
          timingValues: finalTimingValues,
          contactResistance: finalContactResistance,
          coilResistance: finalCoilResistance
        };
        localStorage.setItem('updateTimeIntervalData', JSON.stringify(dataToSave));
        
        
      } catch (error) {
       
      }
    }
  }, [isUpdateMode, reportToUpdate]);

  
useEffect(() => {
 
  const formData = {
    numberOfCoils,
    timingValues,
    contactResistance,
    coilResistance
  };
  
  localStorage.setItem('updateTimeIntervalData', JSON.stringify(formData));

}, [numberOfCoils, timingValues, contactResistance, coilResistance]);

  const handleCoilCountChange = (event) => {
    const newNumberOfCoils = parseInt(event.target.value, 10);
    setNumberOfCoils(newNumberOfCoils);
    
   
    const formData = {
      numberOfCoils: newNumberOfCoils,
      timingValues,
      contactResistance,
      coilResistance
    };
    localStorage.setItem('updateTimeIntervalData', JSON.stringify(formData));
    
  };

  const handleBackClick = () => {
    if (goBack) {
      goBack();
    } else {
      setShowCircuitBreakerForm(true);
    }
  };

  const handleTimingInputChange = (rowKey, phase, value) => {
    const cleaned = value.replace(/[^0-9.]/g, '');
    const key = `${rowKey}-${phase}`;

    let updatedTimingValues;
    let finalValue;
    if (cleaned.trim() === '') {
      finalValue = '';
      updatedTimingValues = { ...timingValues, [key]: '' };
      setTimingValues(updatedTimingValues);
    } else {
      finalValue = `${cleaned}`;
      updatedTimingValues = { ...timingValues, [key]: finalValue };
      setTimingValues(updatedTimingValues);
    }
    
    
    const formData = {
      numberOfCoils,
      timingValues: updatedTimingValues,
      contactResistance,
      coilResistance
    };
    localStorage.setItem('updateTimeIntervalData', JSON.stringify(formData));
   
  };

  const handleContactInputChange = (phase, value) => {
    const cleaned = value.replace(/[^0-9.]/g, '');
    const updatedContactResistance = { ...contactResistance, [phase]: cleaned };
    setContactResistance(updatedContactResistance);
    
    
    const formData = {
      numberOfCoils,
      timingValues,
      contactResistance: updatedContactResistance,
      coilResistance
    };
    localStorage.setItem('updateTimeIntervalData', JSON.stringify(formData));
   
  };

  const handleCoilInputChange = (key, value, index = null) => {
    const cleaned = value.replace(/[^0-9.]/g, '');
    
    let updatedCoilResistance;
    if (key === 'tripping') {
      updatedCoilResistance = {
        ...coilResistance,
        tripping: { 
          ...coilResistance.tripping, 
          [index]: { 
            ...coilResistance.tripping[index],
            value: cleaned,
            unit: coilResistance.tripping[index]?.unit || 'Ω'
          } 
        }
      };
    } else {
      updatedCoilResistance = { 
        ...coilResistance, 
        [key]: {
          ...coilResistance[key],
          value: cleaned
        }
      };
    }
    
    setCoilResistance(updatedCoilResistance);
    
  
    const formData = {
      numberOfCoils,
      timingValues,
      contactResistance,
      coilResistance: updatedCoilResistance
    };
    localStorage.setItem('updateTimeIntervalData', JSON.stringify(formData));
   
  };

  const handleUnitChange = (key, unit, index = null) => {
    let updatedCoilResistance;
    if (key === 'tripping') {
      updatedCoilResistance = {
        ...coilResistance,
        tripping: { 
          ...coilResistance.tripping, 
          [index]: { 
            ...coilResistance.tripping[index],
            unit: unit
          } 
        }
      };
    } else {
      updatedCoilResistance = { 
        ...coilResistance, 
        [key]: {
          ...coilResistance[key],
          unit: unit
        }
      };
    }
    
    setCoilResistance(updatedCoilResistance);
    
  
    const formData = {
      numberOfCoils,
      timingValues,
      contactResistance,
      coilResistance: updatedCoilResistance
    };
    localStorage.setItem('updateTimeIntervalData', JSON.stringify(formData));
    
  };

 
const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  if (showCircuitBreakerForm) {
    return <TestUpdate />;
  }

  if (showContactForm) {
    const testFormData = {
      contactResistance,
      coilResistance,
      timingValues,
      numberOfCoils
    };
    
    return <OperationalUpdate 
      goBack={() => setShowContactForm(false)} 
      contactTestData={testFormData}
      reportToUpdate={reportToUpdate}
      isUpdateMode={isUpdateMode}
    />;
  }

  return (
   <div className="act-01">
    <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      <div className="act-02">
        <div className="act-03">
          <h2 className="act-04">CONTACT RESISTANCE TEST</h2>
          <div className="act-05">
            {['R', 'Y', 'B'].map(phase => (
              <div key={phase} className="act-06">
                <div className="act-07">{phase} - Phase</div>
                <input
                  type="text"
                  className="act-08"
                  placeholder="Enter Measured Resistance"
                  value={contactResistance[phase]}
                  onChange={(e) => handleContactInputChange(phase, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="act-03">
          <h2 className="act-04">COIL RESISTANCE CHECK</h2>
          <div className="act-09">
            <div className="act-10">
              <div className="act-11">Closing Coil</div>
              <div className="act-12">
                <input
                  type="text"
                  className="act-13"
                  placeholder="Enter Measured Values"
                  value={coilResistance.closing.value || ''}
                  onChange={(e) => handleCoilInputChange('closing', e.target.value)}
                />
                <select
                  value={coilResistance.closing.unit}
                  onChange={(e) => handleUnitChange('closing', e.target.value)}
                  className="act-14"
                >
                  <option value="Ω">Ω</option>
                  <option value="MΩ">MΩ</option>
                  <option value="GΩ">GΩ</option>
                  <option value="TΩ">TΩ</option>
                  <option value="KΩ">KΩ</option>
                </select>
              </div>
            </div>

            {Array.from({ length: numberOfCoils }, (_, index) => (
              <div key={index} className="act-10">
                <div className="act-11">Tripping Coil-{index + 1}</div>
                <div className="act-12">
                  <input
                    type="text"
                    className="act-13"
                    placeholder="Enter Measured Values"
                    value={coilResistance.tripping[index]?.value || ''}
                    onChange={(e) => handleCoilInputChange('tripping', e.target.value, index)}
                  />
                  <select
                    value={coilResistance.tripping[index]?.unit || 'Ω'}
                    onChange={(e) => handleUnitChange('tripping', e.target.value, index)}
                    className="act-14"
                  >
                    <option value="Ω">Ω</option>
                    <option value="MΩ">MΩ</option>
                    <option value="GΩ">GΩ</option>
                    <option value="TΩ">TΩ</option>
                    <option value="KΩ">KΩ</option>
                  </select>
                </div>
              </div>
            ))}

            <div className="act-10">
              <div className="act-11">Spring Charge Motor</div>
              <div className="act-12">
                <input
                  type="text"
                  className="act-13"
                  placeholder="Enter Measured Values"
                  value={coilResistance.spring.value}
                  onChange={(e) => handleCoilInputChange('spring', e.target.value)}
                />
                <select
                  value={coilResistance.spring.unit}
                  onChange={(e) => handleUnitChange('spring', e.target.value)}
                  className="act-14"
                >
                  <option value="Ω">Ω</option>
                  <option value="MΩ">MΩ</option>
                  <option value="GΩ">GΩ</option>
                  <option value="TΩ">TΩ</option>
                  <option value="KΩ">KΩ</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="act-03 act-15">
        <div className="act-16">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h2 className="act-04" style={{ marginBottom: 0 }}>TIMING INTERVAL TEST</h2>
            <div className="act-17">
              <span>No Of Coils</span>
              <div className="act-18">
                <select
                  value={numberOfCoils || ''}
                  onChange={handleCoilCountChange}
                  className="act-19"
                >
                  {[1, 2, 3, 4].map(num => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </select>
                <div className="act-20"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="act-21">
          <div className="act-22">Reference</div>
          <div className="act-22">R - Phase (mSec)</div>
          <div className="act-22">Y - Phase (mSec)</div>
          <div className="act-22">B - Phase (mSec)</div>

          <div className="act-23">Close</div>
          {['R', 'Y', 'B'].map(phase => (
            <input
              key={`Close-${phase}`}
              className="act-24"
              placeholder={`Enter ${phase}-Phase`}
              value={timingValues[`Close-${phase}`] || ''}
              onChange={(e) => handleTimingInputChange('Close', phase, e.target.value)}
            />
          ))}

          {Array.from({ length: numberOfCoils }, (_, index) => (
            <React.Fragment key={`open-${index}`}>
              <div className="act-23">Open TC-{index + 1}</div>
              {['R', 'Y', 'B'].map(phase => (
                <input
                  key={`Open-${index}-${phase}`}
                  className="act-24"
                  placeholder={`Enter ${phase}-Phase`}
                  value={timingValues[`Open-${index}-${phase}`] || ''}
                  onChange={(e) => handleTimingInputChange(`Open-${index}`, phase, e.target.value)}
                />
              ))}
            </React.Fragment>
          ))}

          {Array.from({ length: numberOfCoils }, (_, index) => (
            <React.Fragment key={`close-open-${index}`}>
              <div className="act-23">Close-Open TC-{index + 1}</div>
              {['R', 'Y', 'B'].map(phase => (
                <input
                  key={`Close-Open-${index}-${phase}`}
                  className="act-24"
                  placeholder={`Enter ${phase}-Phase`}
                  value={timingValues[`Close-Open-${index}-${phase}`] || ''}
                  onChange={(e) => handleTimingInputChange(`Close-Open-${index}`, phase, e.target.value)}
                />
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="act-25">
        <button className="act-26" onClick={handleBackClick}>Back</button>
        <button
          className="act-26"
          onClick={() => setShowContactForm(true)}
        >
          Next
        </button>
        
      </div>
    </div>
  );
}

export default CircuitBreakerTestForm;